// extracted by mini-css-extract-plugin
export default {"container":"fNH1GHL744D2qqtxodtk","containerBody":"ASVLMZf1UORiXW5pO676"};